import {
  AutoResizeTextAreaInput,
  AutoResizeTextAreaInputProps,
} from "@/flokit/compound/inputs/auto-resize-text-area-input/auto-resize-text-area-input";

export const FreeTextEdit = (props: AutoResizeTextAreaInputProps) => {
  return <AutoResizeTextAreaInput {...props} />;
};
